export function makeWorkplaceDetailDeeplink(workplaceId: string): string {
  return makeDeepLink(`/workplace/${workplaceId}`);
}

export function makeJobOfferDeeplink(offerId: string): string {
  // Crew App cannot handle job-offer deeplink correctly, so we use offer route instead
  // ref: https://mercari.slack.com/archives/C07PP7X9FBK/p1748998890095899?thread_ts=1748320095.305049&cid=C07PP7X9FBK
  return makeDeepLink(`/offers/${offerId}`);
}

export function makeTopDeepLink(): string {
  return makeDeepLink('/');
}

// All deeplinks are handled via the AppsFlyer SDK
// see: https://dev.appsflyer.com/hc/docs/dl_work_flow#marketer-role
export function makeDeepLink(path: string) {
  const deepLinkValue = encodeURIComponent(path);
  return `${process.env.NEXT_PUBLIC_APPS_FLYER_URL}?deep_link_value=${deepLinkValue}&af_force_deeplink=true`;
}
